export const ThemeStyled = {
  colors: {
    red: '#F43636',
    lightRed: '#FD6060',
    darkRed: '#E53535',
    bordeaux: '#9C2D2D',

    salmon: '#F77272',

    gray: '#BCBCBC',
    grayLight: '#8F8F8F',
    grayBorder: '#5B5B5B',
    graySemiDark: '#404040',
    grayDark: '#313131',

    darkGray: '#1B1B1B',
    darkLight: '#1C1C1C',

    white: '#fff',
    black: '#000',

    yellow: '#ffcb6b',
    purple: '#d7b2f0',
    purpleGray: '#303B42',
    green: '#c3e88d'
  }
}
